import { render } from "./HeroiconsOutlineDotsVertical.vue?vue&type=template&id=68f9cf6d"
const script = {}

import exportComponent from "/www/yadonor/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDotsVertical.vue"]])

export default __exports__